// src/pages/usa/colorado/Ouray.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Ouray ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function Ouray() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__ourayBackRouteSet) {
      window.__ourayBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Ouray, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>🏞️ Discover Ouray, Colorado</h2>

            <p>
              Ouray, Colorado is a gem tucked deep in the San Juan Mountains — often called the
              “Switzerland of America” for its dramatic alpine scenery. It blends rugged adventure with
              small‑town charm, historic streets, and stunning trails. I’ve visited twice in summer, and
              it’s always peaceful, scenic, and full of character.
            </p>

            {/* GETTING THERE */}
            <h3>🚗 Getting There</h3>

            <p>
              The drive from Denver to Ouray is about 6 hours (300 miles). Most visitors fly into Denver
              International Airport (DEN), then follow I‑70 west to US‑50, and finally US‑550 — which
              includes the breathtaking Million Dollar Highway.
            </p>

            {/* PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Box Canyon:</strong> A powerful waterfall plunging through a narrow quartzite gorge.
                  The short walk is scenic, and the high bridge trail gives sweeping views of Ouray.<br />
                  <a
                    href="https://www.google.com/maps?q=38.01811885557337,-107.67744615679781"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Box Canyon
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Lower Cascade:</strong> A refreshing waterfall where you can walk behind the falls
                  if you’re comfortable with heights and narrow paths.<br />
                  <a
                    href="https://www.google.com/maps?q=38.02493736926673,-107.66691045213045"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Lower Cascade
                  </a>
                </div>
              </li>
            </ul>

            {/* HIDDEN GEMS */}
            <h3>⛰️ Other Hidden Gems</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Ouray Via Ferrata:</strong> A thrilling cliffside route with iron rungs and cables
                  carved into the Uncompahgre Gorge.<br />
                  <a
                    href="https://www.ourayviaferrata.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Route Info
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Bear Creek Falls:</strong> A dramatic roadside waterfall along the Million Dollar
                  Highway.<br />
                  <a
                    href="https://www.google.com/maps?q=37.99990957547565,-107.66097140803585"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Bear Creek Falls
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Ouray Hot Springs:</strong> Naturally heated, sulfur‑free pools surrounded by
                  mountain views.<br />
                  <a
                    href="https://www.google.com/maps?q=38.021185423273714,-107.67256161210047"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Ouray Hot Springs
                  </a>
                </div>
              </li>
            </ul>

            {/* PLACES TO STAY */}
            <h3>🛏️ Places to Stay</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>St. Elmo Hotel:</strong> A well‑preserved historic hotel with clean rooms and great service.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hotel Ouray:</strong> Boutique‑style lodging with modern amenities.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Twin Peaks Lodge & Hot Springs:</strong> Comfortable rooms with access to hot springs.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Box Canyon Lodge & Hot Springs:</strong> Rustic charm with private outdoor soaking tubs.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Beaumont Hotel & Spa:</strong> Elegant and historic, ideal for luxury travelers.
                </div>
              </li>
            </ul>

            {/* AFFILIATE BLOCK */}
            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>

            {/* VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos I took from Cascade Falls and Box Canyon:</p>

            <p>
              <a
                href="https://youtu.be/Agp7jvl-QqU?si=0yVukks2yt46j0SU"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cascade Falls Park
              </a>
              <br />
              <a
                href="https://youtu.be/0zpbPMksvpk?si=dDZLJ-ZBTsNZzt0a"
                target="_blank"
                rel="noopener noreferrer"
              >
                Box Canyon
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN — IMAGES */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/0zpbPMksvpk?si=dDZLJ-ZBTsNZzt0a"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img src="/images/usa/colorado/ouray/boxcanyon.jpg" alt="Box Canyon Video" />
            </a>

            <a
              href="https://youtu.be/Agp7jvl-QqU?si=0yVukks2yt46j0SU"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img src="/images/usa/colorado/ouray/lowercascadefall.jpg" alt="Lower Cascade Video" />
            </a>

            <img src="/images/usa/colorado/ouray/boxcanyonstairs.jpg" alt="Box Canyon Stairs" />
            <img src="/images/usa/colorado/ouray/bearcreekfalls.jpg" alt="Bear Creek Falls" />
            <img src="/images/usa/colorado/ouray/thetown.jpg" alt="The Town" />
            <img src="/images/usa/colorado/ouray/townfromabove.jpg" alt="Town From Above" />
            <img src="/images/usa/colorado/ouray/lowercascade.jpg" alt="Lower Cascade" />
            <img src="/images/usa/colorado/ouray/lcascade.jpg" alt="Behind Lower Cascade" />
            <img src="/images/usa/colorado/ouray/ouraysign.jpg" alt="Ouray Sign" />
            <img src="/images/usa/colorado/ouray/bridgeoverthecanyon.jpg" alt="Bridge Over the Canyon" />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
